function GemPagesVariantChangeHandler() {
    const gp = document.querySelector('gp-product-variants');
    if (!gp) return;

    document.addEventListener('change', () => {
        kachingJob(gp);
    });
    kachingJob(gp);
}

function kachingJob(gp) {
    const selectedVariant = gp.querySelector(".option-item-active");
    if (!selectedVariant) return;
    
    const selectedInput = selectedVariant.querySelector("input");
    if (!selectedInput) return;
    
    const title = selectedInput.value;
    syncKachingBundleSelectsToTitle(title);
}

function syncKachingBundleSelectsToTitle(title) {
  if (!title) return;

  const products = document.querySelectorAll(".kaching-bundles__bundle-products__product");
  products.forEach((productEl) => {
    const select = productEl.querySelector(".kaching-bundles__bar-variant-select");
    if (!select) return;

    if (select.value === title) return;

    const match = Array.from(select.options).find(opt => opt.value === title);

    if (!match) return;

    select.value = match.value;

    select.dispatchEvent(new Event("change", { bubbles: true }));
  });
}

function waitForKachingSelects({ timeout = 15000 } = {}) {
  const selector = ".kaching-bundles__bar-variant-select";

  if (document.querySelector(selector)) return Promise.resolve(true);

  return new Promise((resolve) => {
    let done = false;

    const finish = (result) => {
      if (done) return;
      done = true;
      observer.disconnect();
      clearTimeout(timer);
      resolve(result);
    };

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) finish(true);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    const timer = setTimeout(() => finish(false), timeout);
  });
}

function waitForElement(selector, { timeout = 15000 } = {}) {
  const el = document.querySelector(selector);
  if (el) return Promise.resolve(el);

  return new Promise((resolve) => {
    let done = false;

    const finish = (result) => {
      if (done) return;
      done = true;
      observer.disconnect();
      clearTimeout(timer);
      resolve(result);
    };

    const observer = new MutationObserver(() => {
      const foundEl = document.querySelector(selector);
      if (foundEl) finish(foundEl);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    const timer = setTimeout(() => finish(null), timeout);
  });
}

function DefaultThemeVariantChangeHandler() {
    if (typeof subscribe !== "function") return;
    if (typeof PUB_SUB_EVENTS === "undefined" || !PUB_SUB_EVENTS?.variantChange) return;

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variantTitle = event?.data?.variant?.title;
        if (!variantTitle) return;
        syncKachingBundleSelectsToTitle(variantTitle);
    });


    try {
        waitForKachingSelects({ timeout: 15000 }).then((found) => {
            if (!found) return;

            const productInfo = document.querySelector("product-info");
            const currentVariantTitle = productInfo?.getSelectedVariant(productInfo)?.title || ''; 

            if (currentVariantTitle) syncKachingBundleSelectsToTitle(currentVariantTitle);
        });
    } catch (e) {
        // ignore
    }
}

/**
 * Replo support
 * Gets the selected variant title from:
 * div[role="option"][aria-selected="true"] p
 */
function getReploSelectedVariantTitle() {
  const selectedOptionText = document.querySelector(
    'div[role="option"][aria-selected="true"] p'
  );

  return selectedOptionText?.textContent?.trim() || "";
}

function syncReploSelectedVariantToKaching() {
  const title = getReploSelectedVariantTitle();
  if (!title) return;

  syncKachingBundleSelectsToTitle(title);
}

/**
 * Watches a hidden variant ID input whose value may be changed programmatically.
 * This covers:
 * - normal change/input events
 * - value attribute mutations
 * - JS property updates that do not trigger events
 */
function watchInputValue(input, callback) {
  if (!input) return;

  let lastValue = input.value;

  const check = () => {
    const currentValue = input.value;

    if (currentValue === lastValue) return;

    lastValue = currentValue;
    callback(currentValue);
  };

  input.addEventListener("change", check);
  input.addEventListener("input", check);

  const observer = new MutationObserver(check);

  observer.observe(input, {
    attributes: true,
    attributeFilter: ["value"],
  });

  const interval = setInterval(check, 150);

  return () => {
    input.removeEventListener("change", check);
    input.removeEventListener("input", check);
    observer.disconnect();
    clearInterval(interval);
  };
}

function ReploVariantChangeHandler() {
  try {
    Promise.all([
      waitForKachingSelects({ timeout: 15000 }),
      waitForElement('product-form input[name="id"]', { timeout: 15000 }),
    ]).then(([kachingFound, variantInput]) => {
      if (!kachingFound || !variantInput) return;

      // Initial sync once both Replo product form and Kaching selects are available
      syncReploSelectedVariantToKaching();

      watchInputValue(variantInput, () => {
        /**
         * Replo may update the selected option UI slightly after the hidden input.
         * requestAnimationFrame + small timeout makes the title read more reliable.
         */
        requestAnimationFrame(() => {
          syncReploSelectedVariantToKaching();

          setTimeout(() => {
            syncReploSelectedVariantToKaching();
          }, 50);
        });
      });
    });
  } catch (e) {
    // ignore
  }
}

document.addEventListener("DOMContentLoaded", () => {
  GemPagesVariantChangeHandler();
  DefaultThemeVariantChangeHandler();

  var replo_page = document.querySelector('#replo-fullpage-element');
  if(replo_page) {
    ReploVariantChangeHandler();
  }
});